import styled from "styled-components";
import { Input } from "antd";
import I18n from "../../i18n";

export const ColorInput = styled(Input).attrs({
	type:"color",
	placeholder:I18n.t("color.placeholder_code"),
})`
    min-width:150px
`;


// WEBPACK FOOTER //
// ./src/components/form/Input.js